export const categories = {
	label: "Categories",
	search: {
		label: "Search",
		placeholder: "Category, subcategory or product",
	},
	add: "Add category",
	categoryModal: {
		create: "New category",
		createSubcategory: "Create subcategory",
		edit: "Edit category",
		inputs: {
			image: "Image",
			name: {
				label: "Name",
				placeholder: "Enter the name",
			},
			description: {
				label: "Description",
				placeholder: "Describe the category",
			},
			priorityLevel: {
				label: "Priority level",
				errorMessage: "Enter a valid priority level (ex: 1, 2, 3...)",
			},
			prefix: "Level",
			chartAccount: {
				label: "Chart of Account",
				placeholder: "Select the chart of accounts",
			},
			printOrder: {
				label: "Category phase",
				placeholder: "Enter the category phase",
			},
			errors: {
				requiredName: "Name is required",
				requiredPriority: "Priority level is required",
				invalidPriority: "Invalid priority level",
				requiredPrintOrder: "Category phase is required",
				invalidPrintOrder: "Invalid category phase",
			},
		},
	},
	columns: {
		product: "Product",
		type: "Type",
		actions: "Actions",
		combo: "Combo",
	},
	priorityLevel: "Priority level {{level}}",
	addSubcategory: "Add subcategory in{{category}}",
	addProduct: "Add product in{{category}}",
	deleteCategory: "Do you want to delete the category? This operation cannot be undone.",
	deleteProduct: "Do you want to delete this product? This operation cannot be undone.",
	productModal: {
		edit: "Edit product",
		create: "Create product",
		inputs: {
			name: {
				label: "Name",
				emptyError: "Product name not filled in",
				noStringError: "Use only valid characters",
				noCategory: "Category name not filled in",
				noPriority: "Invalid priority level",
			},
			type: {
				label: "Product type",
				placeholder: "Select a product type",
				error: "Select a product type",
			},
			image: "Image",
			hasAlcohol: "Contains Alcohol",
		},
	},
	subcategory: "subcategory",
	subcategories: "Subcategories",
	description: "Description",
	chartAccount: "Chart of Accounts",
	products: "Products",
};
